import React, { useState, useEffect } from 'react';
import { BoxLoader } from '../components/BoxLoader';

type UseLoaderTypes = (
  description: string,
  milliseconds: number,
  isRunAsSimpleComponent: boolean
) => JSX.Element | null;

export const useTimeoutLoader: UseLoaderTypes = (
  description,
  milliseconds,
  isRunAsSimpleComponent
) => {
  const [showLoader, setShowLoader] = useState<boolean>(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), milliseconds);

    return () => {
      clearTimeout(timer);
    };
  }, [milliseconds]);

  return showLoader ? (
    <BoxLoader
      isRunAsSimpleComponent={isRunAsSimpleComponent}
      description={description}
      defaultLoader={false}
    />
  ) : null;
};
